import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import {
  APP_NAVIGATION_CONTEXT_DESCRIPTORS,
  AppNavigationContext,
} from '@core/models/app-navigation.model';
import { filter } from 'rxjs';

const ACTIVE_CONTEXT_DATA_KEY = 'activeContext';

@Injectable({ providedIn: 'root' })
export class AppNavigationContextService {
  private readonly router = inject(Router);
  private readonly navigationEnd = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    ),
  );

  public readonly activeContext = computed(() => {
    const _ = this.navigationEnd();

    return resolveAppNavigationContext(this.router.routerState.snapshot.root);
  });
}

export function resolveAppNavigationContext(
  root: ActivatedRouteSnapshot,
): AppNavigationContext | null {
  let route: ActivatedRouteSnapshot | null = root;
  let activeContext: AppNavigationContext | null = null;

  while (route) {
    if (
      Object.prototype.hasOwnProperty.call(route.data, ACTIVE_CONTEXT_DATA_KEY)
    ) {
      activeContext = isAppNavigationContext(
        route.data[ACTIVE_CONTEXT_DATA_KEY],
      )
        ? route.data[ACTIVE_CONTEXT_DATA_KEY]
        : null;
    }

    route = route.firstChild;
  }

  return activeContext;
}

function isAppNavigationContext(value: unknown): value is AppNavigationContext {
  return APP_NAVIGATION_CONTEXT_DESCRIPTORS.some(
    ({ context }) => context === value,
  );
}
